import { render, staticRenderFns } from "./IndigenousAncestryOfChild.vue?vue&type=template&id=fb0cb55a"
import script from "./IndigenousAncestryOfChild.vue?vue&type=script&lang=ts"
export * from "./IndigenousAncestryOfChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports